import { cluesFromLine, cluesFromGrid } from '@org/nonogram-engine';

export { cluesFromLine as calculateLineClues };

export function calculateRowClues(solution: boolean[][]): number[][] {
  return cluesFromGrid(solution).rows;
}

export function calculateColumnClues(solution: boolean[][]): number[][] {
  return cluesFromGrid(solution).cols;
}
